import { Injectable } from '@angular/core';
import { DataToolsService } from '../services/data-tools.service';
import { SharedToolsService } from '../services/shared-tools.service';
import { take } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

@Injectable({ providedIn: 'root' })
export class DataInitService {
	constructor(
		private dataToolsService: DataToolsService,
		private sharedToolsService: SharedToolsService
	) {}

	getGlobalTextsOnce(callback: (txt: any) => void) {
		this.dataToolsService.currentGlobalTexts
			.pipe(take(1))
			.subscribe(object => {
				if (!object) {
					this.sharedToolsService.getGlobalTextsObs().pipe(take(1)).subscribe((newObject: any) => {
						this.dataToolsService.setGlobalTexts(newObject);
						callback(newObject);
					});
				} else {
					callback(object);
				}
			});
	}

	getNameJsonReady(callback: (nameJson: string) => void) {
		this.sharedToolsService.getNameJson()
			.then(() => {
				this.dataToolsService.currentNameJson
					.pipe(take(1))
					.subscribe(nameJson => {
						if (nameJson) callback(nameJson);
					});
			})
			.catch(() => {
				console.error("Error getting nameJson");
			});
	}

	getModalTextsOnce(callback: (modalsTxt: any) => void) {
		this.sharedToolsService.getModalTexts()
			.pipe(take(1))
			.subscribe(modalsTxt => {
				callback(cloneDeep(modalsTxt));
			});
	}

	getModalTextsForModalComponentOnce(callback: (modalsTxt: any) => void) {
		this.sharedToolsService.getModalTextsForModalComponent()
			.pipe(take(1))
			.subscribe(modalsTxt => {
				callback(cloneDeep(modalsTxt));
			});
	}
}
